import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { DashboardKeys } from '@/modules/dashboard/keys'
import {
	GetTransactionSummaryRequest,
	GetTransactionSummaryResponse,
} from '@/modules/dashboard/type'
import { getTransactionSummary } from '../../services'

export default function useQueryGetTransactionSummary(
	payload: GetTransactionSummaryRequest,
	options?: Omit<
		UseQueryOptions<GetTransactionSummaryResponse>,
		'queryKey' | 'queryFn'
	>,
) {
	return useQuery<GetTransactionSummaryResponse>({
		queryKey: [DashboardKeys.TransactionSummary, payload],
		queryFn: () => getTransactionSummary(payload),
		...options,
	})
}
